import { render, staticRenderFns } from "./settingsManage.vue?vue&type=template&id=18a933e0"
import script from "./settingsManage.vue?vue&type=script&lang=js"
export * from "./settingsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports